import Siema from '../../../js/vendor/siema';
import { Helper } from '../../../js/util/helper';

export default class SlideContainer {
  constructor( node ) {
    this.node = node;

    if (!this.node.closest('.slide-container-wrapper').classList.contains( 'one-slider-item' )) {
      this.handleButtonFocusOff( this.node );
      this.slider = null;
      this.handleSlide();
      this.addResizeEvent();
      this.initImageHeightHandler();
    }
  }
  initImageHeightHandler() {
    if ( this.node.classList.contains( 'slide-container--4' )) {
      let pictures = this.node.querySelectorAll( '.picture-container' );
      pictures.forEach(( picture ) => {
        let wrapper = Helper.getClosest( picture, '.slide-container__item-container' );
        let pictureImage = picture.querySelector( 'img' );
        pictureImage.onload = function() {
          let sliderContainer = Helper.getClosest( wrapper, '.slide-container__center' );

          if ( sliderContainer !== null ) {
            if ( sliderContainer.offsetHeight < wrapper.offsetHeight ) {
              sliderContainer.style.height = wrapper.offsetHeight + 'px';
            }
          }
        };
      });
    }
  }
  handleButtonFocusOn( container ) {
    let buttons = container.querySelectorAll( '.button' );

    for ( let button of buttons ) {
      button.tabIndex = 0;
    }
  }
  handleButtonFocusOff( container ) {
    let buttons = container.querySelectorAll( '.button' );

    for ( let button of buttons ) {
      button.tabIndex = -1;
    }
  }
  handleSlide() {
    this.slider = this.initSlider();
    for ( let slide of this.node.children[ 0 ].children ) {
      slide.classList.add( 'slide-container__slide' );
      if ( window.innerWidth < 1320 ) {
        if ( this.node.classList.contains( 'slide-container--2' ) || this.node.classList.contains( 'slide-container--4' )) {
          slide.style.paddingRight = '1.25rem';
          slide.style.paddingLeft = '1.25rem';
        }
      } else {
        if ( this.node.classList.contains( 'slide-container--4' )) {
          slide.style.paddingRight = 3.9 / ( this.slider.innerElements.length + 2 ) + '%';
          slide.style.paddingLeft = 0;
        } else if ( this.node.classList.contains( 'slide-container--2' )) {
          slide.style.padding = '0 ' + 3.9 / ( this.slider.innerElements.length + 2 ) + '%';
        }
      }
    }
    this.addPagination();
    this.addButton();
    this.setActivePagination( 0 );

    if ( this.node.classList.contains( 'slide-container--2' ) || this.node.classList.contains( 'slide-container--4' )) {
      window.addEventListener( 'load', () => {
        this.setHeight();
        this.addResizeEvent( true );
      });
    }
  }
  initSlider() {
    return new Siema({
      selector: this.node,
      loop: true,
      onChange: this.setActivePagination.bind( this )
    });
  }
  addPagination() {
    let wrapper = Helper.getClosest( this.node, '.slide-container-wrapper' );
    let paginationBtns = wrapper.querySelectorAll( '.slide-container__pagination-box' );
    for ( let paginationBtn of paginationBtns ) {
      paginationBtn.addEventListener( 'click', () => {
        const index = paginationBtn.getAttribute( 'data-index' );
        this.slider.goTo( index );
      });
    }
  }
  addButton() {
    let wrapper = Helper.getClosest( this.node, '.slide-container-wrapper' );

    wrapper.children[ 0 ].addEventListener( 'click', () => {
      this.slider.prev();
    });

    wrapper.children[ 1 ].addEventListener( 'click', () => {
      this.slider.next();
    });
  }
  setActivePagination( index = -1 ) {
    let wrapper = Helper.getClosest( this.node, '.slide-container-wrapper' ),
      paginationBtns = wrapper.querySelectorAll( '.slide-container__pagination-box' ),
      active = wrapper.querySelector( '.slide-container__pagination-box--active' );
    const current = ( index === -1 ) ? this.slider.currentSlide : index;
    this.handleTabIndex( current, active );
    if ( active !== null ) {
      active.classList.remove( 'slide-container__pagination-box--active' );
    }
    paginationBtns[ current ].classList.add( 'slide-container__pagination-box--active' );
  }
  handleTabIndex( current, prev ) {
    let container = this.node.children[ 0 ].children;

    if ( prev === null ) {
      prev = current;
    } else {
      prev = parseInt( prev.getAttribute( 'data-index' ));
    }

    this.handleButtonFocusOn( container[ current + 1 ]);

    if ( current !== prev ) {
      this.handleButtonFocusOff( container[ prev + 1 ]);
    }
  }
  setHeight() {
    const h = this.node.offsetHeight;
    this.node.children[ 0 ].style.height = h + 'px';
    this.node.children[ 0 ].classList.add( 'slide-container__center' );
  }
  addResizeEvent( height = false ) {

    this.changeButtonIcon();

    window.addEventListener( 'resize', () => {

      for ( let slide of this.node.children[ 0 ].children ) {
        slide.classList.add( 'slide-container__slide' );
        if ( window.innerWidth < 1320 ) {
          if ( this.node.classList.contains( 'slide-container--2' ) || this.node.classList.contains( 'slide-container--4' )) {
            slide.style.paddingRight = '1.25rem';
            slide.style.paddingLeft = '1.25rem';
          }
        } else {
          if ( this.node.classList.contains( 'slide-container--4' )) {
            slide.style.paddingRight = 3.9 / ( this.slider.innerElements.length + 2 ) + '%';
            slide.style.paddingLeft = 0;
          } else if ( this.node.classList.contains( 'slide-container--2' )) {
            slide.style.padding = '0 ' + 3.9 / ( this.slider.innerElements.length + 2 ) + '%';
          }
        }
      }

      if ( height ) {
        this.setHeight();
      }

      this.changeButtonIcon();

    });
  }
  changeButtonIcon() {
    let wrapper = Helper.getClosest( this.node, '.slide-container-wrapper' );
    let button = wrapper.children[ 0 ].children[ 0 ].children[ 0 ].children[ 0 ];

    if ( window.innerWidth >= 1024 && button.getAttribute( 'xlink:href' ) !== '#swipe_arrow_desktop' ) {
      wrapper.children[ 0 ].children[ 0 ].children[ 0 ].children[ 0 ].setAttribute( 'xlink:href', '#swipe_arrow_desktop_left' );
      wrapper.children[ 1 ].children[ 0 ].children[ 0 ].children[ 0 ].setAttribute( 'xlink:href', '#swipe_arrow_desktop_left' );
    } else if ( window.innerWidth < 1024 && button.getAttribute( 'xlink:href' ) === '#swipe_arrow_desktop_left' ) {
      wrapper.children[ 0 ].children[ 0 ].children[ 0 ].children[ 0 ].setAttribute( 'xlink:href', '#swipe_arrow_mobile_right' );
      wrapper.children[ 1 ].children[ 0 ].children[ 0 ].children[ 0 ].setAttribute( 'xlink:href', '#swipe_arrow_mobile_right' );
    }
  }
}
